
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/firmes",
      function () {
        return require("private-next-pages/3catinfo/firmes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/firmes"])
      });
    }
  